<sm-toolbar *ngIf="isAdmin">
    <p-button styleClass="p-button-warning" icon="fas fa-cog" label="Administration" (onClick)="adminClick()">
    </p-button>
    <p-button styleClass="p-button-warning" icon="fas fa-cog" label="Administration (Grundschule)" routerLink="/enaio-certificates/grade-book/admin/{{_SchoolType.elementary}}/{{year}}/{{isHalfYear}}">
    </p-button>
    <p-button styleClass="p-button-warning" icon="fas fa-cog" label="Administration (Gesamtschule)" routerLink="/enaio-certificates/grade-book/admin/{{_SchoolType.secondary}}/{{year}}/{{isHalfYear}}">
    </p-button>
    <p-dropdown [styleClass]="'width200'" id="year" [options]="years"
        [(ngModel)]="year" (onChange)="selectedYearChanged()">
    </p-dropdown>
</sm-toolbar>
<p-card header="Bitte wählen Sie eine Klasse aus">
  <div *ngFor="let grade of getExistingGrades()" class="grid">
    <ng-container *ngFor="let schoolClass of schoolClasses">
      <div *ngIf="schoolClass.grade == grade && (isAdmin || schoolClass.hasPermission(userName))" class="col-6 md:col-2 xl:col-1">
        <p-card [styleClass]="'ui-card-shadow sm-card ' + schoolClass.getGuiClass()">
          <a [style.width]="'100%'" routerLink="/enaio-certificates/grade-book/class/{{schoolClass.id}}/{{isHalfYear ? 1 : 0}}"
              routerLinkActive="active">{{schoolClass.getDisplayName()}}</a>
        </p-card>
      </div>
    </ng-container>
    <br>
  </div>
</p-card>
